import { SOURCE_LABELS } from "./growthConstants";

// Dashboard de métricas encima del tablero — secciones 17-20 del spec: totales, embudo de
// conversión y desglose por fuente (para saber qué canal de captación funciona mejor).
export default function GrowthStats({ stats }) {
  if (!stats) return null;

  const totals = [
    { label: "Oportunidades", value: stats.total },
    { label: "Contactadas", value: stats.contacted },
    { label: "Respondieron", value: stats.replied },
    { label: "Registrados", value: stats.registered },
    { label: "Activados", value: stats.activated },
    { label: "Clientes", value: stats.customers },
  ];
  const conversions = [
    { label: "Contactadas → Respondieron", value: stats.conversion.contactedToReply },
    { label: "Contactadas → Registrados", value: stats.conversion.contactedToRegistered },
    { label: "Registrados → Activados", value: stats.conversion.registeredToActivated },
    { label: "Registrados → Clientes", value: stats.conversion.registeredToCustomer },
    { label: "Activados → Clientes", value: stats.conversion.activatedToCustomer },
  ];

  return (
    <div className="space-y-3" data-testid="growth-stats">
      <div className="grid grid-cols-3 gap-2 sm:grid-cols-6">
        {totals.map((t) => (
          <div key={t.label} className="rounded-lg border border-slate-200 bg-white p-2.5 text-center">
            <div className="text-lg font-bold text-slate-900">{t.value}</div>
            <div className="text-[10px] text-slate-400">{t.label}</div>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap gap-2">
        {conversions.map((c) => (
          <div key={c.label} className="rounded-lg border border-slate-100 bg-slate-50 px-2.5 py-1.5 text-xs text-slate-500">
            {c.label}: <span className="font-semibold text-slate-700">{c.value}%</span>
          </div>
        ))}
      </div>
      {stats.bySource?.length > 0 && (
        <div className="overflow-x-auto rounded-lg border border-slate-200">
          <table className="w-full text-left text-xs">
            <thead className="bg-slate-50 text-slate-400">
              <tr>
                <th className="px-3 py-2 font-medium">Fuente</th>
                <th className="px-3 py-2 text-right font-medium">Oportunidades</th>
                <th className="px-3 py-2 text-right font-medium">Contactadas</th>
                <th className="px-3 py-2 text-right font-medium">Registros</th>
                <th className="px-3 py-2 text-right font-medium">Clientes</th>
              </tr>
            </thead>
            <tbody>
              {stats.bySource.map((s) => (
                <tr key={s.source} className="border-t border-slate-100">
                  <td className="px-3 py-2 font-medium text-slate-700">{SOURCE_LABELS[s.source] || s.source}</td>
                  <td className="px-3 py-2 text-right">{s.opportunities}</td>
                  <td className="px-3 py-2 text-right">{s.contacted}</td>
                  <td className="px-3 py-2 text-right">{s.registered}</td>
                  <td className="px-3 py-2 text-right">{s.customers}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
